import { render } from "./Grid.vue?vue&type=template&id=485ae4b4"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/digiworks/SecoursCatholique/Secours-Catholique_Mots_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__